/*
  TABS
  */
/**
 * TABS
 * switch between tabs
 */

// switch content
$(".tab").click(function () {
	var index = $(".tab").index(this);

	$(".block_container").each(function () {
		var bc = $(".block_container");

    //hide/show block_container
    if (bc.index(this) === index)
    	$(this).addClass("active");
    else
    	$(this).removeClass("active");
  });

  // switch tab
  $(".tab").each(function() {
  	$(this).removeClass("active");
  });

  $(this).addClass("active");
});

//display/hide Tracking Tips
$(".tracking_tips_button").click(function () {
	$(".triangle, .tracking_list").toggleClass("active");
});
